import React, {useMemo} from 'react';
import dataTypes from '../../assets/json/datenTypen.json';

export const TemperatureBackground = ({item, value, mapScale, broadcaster}) => {
  const style = useMemo(() => {
    let transform = '';
    if (typeof item.ui.offset !== 'undefined') {
      transform = `translateX(${item.ui.offset.x}px) translateY(${item.ui.offset.y}px)`;
    }
    return {
      fontSize: item.ui.fontSize * mapScale + 'px',
      transform,
      fontFamily:
        typeof item.ui.fontFamily !== 'undefined' ? item.ui.fontFamily : '',
      color:
        typeof item.ui.fontColor !== 'undefined' ? item.ui.fontColor : 'white'
    };
  }, [item, mapScale]);
  return (
    <div
      className='item-background item-background-temperature'
      style={style}
      data-item-id={item.id}>
      <div
        style={{
          width: '100%',
          textAlign: ['RBB', 'ARD'].includes(broadcaster) ? 'left' : 'center'
        }}>
        {value}
        {dataTypes[item.ui.unit].unit}
      </div>
    </div>
  );
};

export default TemperatureBackground;
